export const AUTH_MODE = 'userPool';
export const CURRENT_PAGE_DEFAULT = 1;
export const ITEM_NUM_PER_PAGE = 100;
export const ITEM_NUM_PER_PAGE_CAMERA_SENSOR = 30;
export const ITEM_NUM_PER_PAGE_LOCATION = 150;
export const MAX_PAGE = 5;

// Time Format
export const MOMENT_FORMAT = 'yyyy/MM/DD HH:mm:ss';
export const DATE_TIME_FORMAT = 'yyyy/MM/DD HH:mm';
export const SHORT_DATE_TIME_FORMAT = 'yy/MM/DD HH:mm';
export const DATE_FORMAT = 'yyyy/MM/DD'

// Sensor
export const DEFAULT_SENSOR_STATUS = -1;
export const UNDEFINED_SENSOR_RECEIVED_TIME = ' ';
export const UNDEFINED_SENSOR_MESSAGE = ' ';
export const UNDEFINED_SENSOR_STATUS = ' ';
export const SENSOR_LOCATION_TEMPLATE = '%location';
export const SENSOR_NAME_TEMPLATE = '%sensor';
export const SENSOR_STATUS_NORMAL = '平常';
export const SENSOR_STATUS_ABNORMAL = '異常';
export const SENSOR_STATUS_ALERT = '警報';
export const SENSOR_STATUS_ATTENTION = '注意';
export const SENSOR_STATUS_GATE_CLOSED = '閉';
export const SENSOR_STATUS_GATE_OPENED = '開';
export const SENSOR_STATUS_CAUTION = '注意';
export const SENSOR_MIN_LAT = -89.85;
export const SENSOR_MAX_LAT = 89.85;
export const SENSOR_MIN_LNG = -180;
export const SENSOR_MAX_LNG = 180;
export const SCENARIO_MIN_ROTATION = 0;
export const SCENARIO_MAX_ROTATION = 359;

export const SPLIT_OPTIONS = [
    { label: '4分割', value: 4 },
    { label: '9分割', value: 9 },
    { label: '16分割', value: 16 },
    { label: '25分割', value: 25 },
    { label: '36分割', value: 36 },
];
export const DEFAULT_SPLIT = 16;

export const DEFAULT_LOCATION = 1;

// zoom threshold to show popup on map screen
export const POPUP_ZOOM_RATIO = 13;

// default zoom level on map screen
export const DEFAULT_ZOOM_RATIO = 5;
export const TARGET_ZOOM_CAMERA = {
    CAMERA1: 'CAMERA1',
    CAMERA2: 'CAMERA2',
}
export const DEBOUNCE_TIME = 300;

export const MAX_SCENARIOS = 20;
export const DEFAULT_SCENARIOS = 10;
export const DUAL_CAMERA_TYPES = ['DOUBLE', 'TWIN'];
export const SETTING_MENU_TYPE = {
    TAB: 'tab',
    DRAWER: 'drawer'
}
export const TWIN_CAMERA_PORT = {
    1: 2000,
    2: 2001
}
export const DEFAULT_TRAFFIC_VOLUME_RETRY_COUNT = 10;
export const DEFAULT_TRAFFIC_VOLUME_STORAGE_PERIOD = 500;
